<template>
  <div>
    <template v-if="!fetchingPromo">
      <PromoCodePaymentMethods
        :card-type="targets.card"
        @card-selection="targets.card = $event"
      />
      <promo-code-geofence
        :dropoffs="targets.dropoff"
        :pickups="targets.pickup"
        @pickup-selection="targets.pickup = $event"
        @dropoff-selection="targets.dropoff = $event"
      />
      <targets-checks
        :selections="targets.devices"
        :options="devices"
        checks-type="devices"
        title="Devices"
        @target-selection="targets.devices = $event"
      />
      <targets-checks
        :selections="targets.phones"
        :options="phonePrefixes"
        checks-type="phone"
        title="Phone Prefix"
        @target-selection="targets.phones = $event"
      />
      <promo-users
        :selected-users="targets.users"
        @users-selection="targets.users = $event"
      />
      <promo-code-services
        :services="promoCode.criteria.services"
        @services-selected="promoCode.criteria.services = $event"
      />
      <promo-code-groups
        :selected-group="targets.groups"
        @groups-selection="targets.groups = $event"
      />
      <promo-code-slices
        :slicings="promoCode.criteria.value.slices"
        @slices-selection="promoCode.criteria.value.slices = $event"
      />
    </template>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="fetchingPromo"
    >
      <b-form
        novalidate
        @submit.prevent="submitPromoCode"
      >
        <validation-observer ref="promoCodeFormRef">
          <b-card>
            <b-card-title>
              <h3>Coupon Details</h3>
            </b-card-title>
            <b-row>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Code"
                  rules="required"
                >
                  <b-form-group
                    label="Code"
                    label-for="promo-code"
                  >
                    <b-form-input
                      id="promo-code"
                      v-model="promoCode.code"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  name="Effective Date"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Effective Date"
                    label-for="effective-date"
                  >
                    <b-form-datepicker
                      id="effective-date"
                      v-model="effectiveDate"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  name="Effective Time"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Effective Time"
                    label-for="effective-time"
                  >
                    <b-form-timepicker
                      id="effective-time"
                      v-model="effectiveTime"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Budgeted Amount"
                  rules="required"
                >
                  <b-form-group
                    label="Budgeted Amount"
                    label-for="promo-budget-amount"
                  >
                    <b-form-input
                      id="promo-budget-amount"
                      v-model.number="promoCode.budgeted_amount"
                      type="number"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col md="4">
                <validation-provider
                  name="Expiry Date"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Expiry Date"
                    label-for="expiry-date"
                  >
                    <b-form-datepicker
                      id="expiry-date"
                      v-model="expiryDate"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  name="Expiry Time"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Expiry Time"
                    label-for="expiry-time"
                  >
                    <b-form-timepicker
                      id="expiry-time"
                      v-model="expiryTime"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Minimum Amount"
                  rules="required"
                >
                  <b-form-group
                    label="Minimum Amount"
                    label-for="promo-min-amount"
                  >
                    <b-form-input
                      id="promo-min-amount"
                      v-model.number="promoCode.criteria.minimum_amount"
                      type="number"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                md="8"
                class="d-flex justify-content-between align-items-center"
              >
                <b-form-group>
                  <b-form-checkbox v-model="promoCode.active">
                    Active
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox v-model="promoCode.criteria.is_cashback">
                    Cashback
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox v-model="promoCode.criteria.first_trip_only">
                    First trip only
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox v-model="promoCode.criteria.is_delay_discount">
                    Delay discount
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox v-model="promoCode.criteria.is_bogo_promo">
                    BOGO Promo
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox v-model="promoCode.criteria.is_extra_payment">
                    Extra Payment
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <b-form-checkbox v-model="promoCode.criteria.include_drop_zone_fees">
                    Include Drop Zone Fees
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Rate Section" />
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Rate"
                  label-for="promo-rate"
                >
                  <b-form-radio-group
                    id="promo-rate"
                    v-model="promoCode.criteria.value.rate"
                    :options="rateOptions"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Amount"
                  :rules="promoCode.criteria.value.slices.length ? '' : 'required'"
                >
                  <b-form-group
                    label="Amount"
                    label-for="promo-amount"
                  >
                    <b-form-input
                      id="promo-amount"
                      v-model.number="promoCode.criteria.value.amount"
                      type="number"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Max Amount"
                  rules="required"
                >
                  <b-form-group
                    label="Max Amount"
                    label-for="promo-max-amount"
                  >
                    <b-form-input
                      id="promo-max-amount"
                      v-model.number="promoCode.criteria.value.max_amount"
                      type="number"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="12">
                <b-form-group label="Retry Section" />
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Per User"
                  rules="required"
                >
                  <b-form-group
                    label="Per User"
                    label-for="promo-per-user"
                  >
                    <b-form-input
                      id="promo-per-user"
                      v-model.number="promoCode.criteria.retry.per_user"
                      type="number"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Max Count"
                  rules="required"
                >
                  <b-form-group
                    label="Max Count"
                    label-for="promo-max-count"
                  >
                    <b-form-input
                      id="promo-max-count"
                      v-model.number="promoCode.criteria.retry.max_count"
                      type="number"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  name="Per Device"
                >
                  <b-form-group
                    label="Per Device"
                    label-for="promo-per-device"
                  >
                    <b-form-input
                      id="promo-per-device"
                      v-model.number="promoCode.criteria.retry.per_device"
                      type="number"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="12">
                <hr>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="First Trips Limit"
                  label-for="promo-first-trips-limit"
                >
                  <b-form-input
                    id="promo-first-trips-limit"
                    v-model.number="promoCode.criteria.first_trips_limit"
                    type="number"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6" />
              <b-col
                md="12"
                class="my-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Is Recurring"
                >
                  <b-form-checkbox
                    v-model="promoCode.criteria.recurrence.is_recurring"
                    class="mb-1"
                    name="is_recurring"
                  >
                    Is Recurring
                  </b-form-checkbox>
                  <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>

                <!-- Show the recurrence form only if is_recurring is true -->
                <div
                  v-if="promoCode.criteria.recurrence.is_recurring"
                >

                  <!-- Recurrence Type Radios -->
                  <validation-provider
                    #default="{ errors }"
                    name="Recurrence Type"
                    rules="required"
                  >
                    <b-form-group label="Recurrence Type">
                      <b-form-radio-group
                        v-model="promoCode.criteria.recurrence.type"
                        :options="recurrenceTypes"
                        name="recurrence_type"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>

                  <!-- Interval - required only if type is custom -->
                  <validation-provider
                    v-if="promoCode.criteria.recurrence.type === 'custom'"
                    #default="{ errors }"
                    name="Interval"
                    :rules="promoCode.criteria.recurrence.type === 'custom' ? 'required' : ''"
                  >
                    <b-form-group
                      label="Interval"
                      label-for="recurrence-interval"
                    >
                      <b-form-input
                        id="recurrence-interval"
                        v-model.number="promoCode.criteria.recurrence.interval"
                        type="number"
                        :disabled="promoCode.criteria.recurrence.type !== 'custom'"
                        placeholder="Enter interval"
                        @input="val => promoCode.criteria.recurrence.interval = val === '' ? null : +val"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>

                  <!-- Usage Limit Per Period - always required -->
                  <validation-provider
                    #default="{ errors }"
                    name="Usage Limit Per Period"
                    rules="required"
                  >
                    <b-form-group
                      label="Usage Limit Per Period"
                      label-for="usage-limit"
                    >
                      <b-form-input
                        id="usage-limit"
                        v-model.number="promoCode.criteria.recurrence.usage_limit_per_period"
                        type="number"
                        placeholder="Enter limit"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>

                  <!-- Valid Days of Week (multiselect) -->
                  <validation-provider
                    #default="{ errors }"
                    name="Valid Days"
                  >
                    <b-form-group label="Valid Days of the Week">
                      <b-form-checkbox-group
                        v-model="promoCode.criteria.recurrence.valid_days_of_week"
                        :options="weekdays"
                        name="valid-days"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>

                  <!-- Valid Hours Start -->
                  <validation-provider
                    #default="{ errors }"
                    name="Valid Hours Start"
                  >
                    <b-form-group
                      label="Valid Hours Start"
                      label-for="valid-hours-start"
                    >
                      <b-form-timepicker
                        id="valid-hours-start"
                        v-model="validHoursStartTime"
                        @input="updateValidHoursStart"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>

                  <!-- Valid Hours End -->
                  <validation-provider
                    #default="{ errors }"
                    name="Valid Hours End"
                  >
                    <b-form-group
                      label="Valid Hours End"
                      label-for="valid-hours-end"
                    >
                      <b-form-timepicker
                        id="valid-hours-end"
                        v-model="validHoursEndTime"
                        @input="updateValidHoursEnd"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </b-form-group>
                  </validation-provider>
                </div>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="$bvModal.show('promo-code-services')"
                >
                  Services
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="$bvModal.show('promo-code-slices')"
                >
                  Promo Slices
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-card-title>
              <h3>Coupon Targets</h3>
            </b-card-title>
            <b-row>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="$bvModal.show('promo-checks-devices')"
                >
                  Devices
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="$bvModal.show('promo-code-users')"
                >
                  Users
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="$bvModal.show('promo-code-geofence')"
                >
                  Geofence
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="$bvModal.show('promo-checks-phone')"
                >
                  Phone Prefix
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="$bvModal.show('promo-code-groups')"
                >
                  Groups
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="$bvModal.show('promo-code-payment-methods')"
                >
                  Cards
                </b-button>
              </b-col>
              <b-col
                md="12"
                class="d-flex justify-content-end mt-2"
              >
                <b-button
                  variant="primary"
                  type="submit"
                >
                  Save
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </validation-observer>
      </b-form>
    </b-overlay>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCardTitle,
  BForm,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BFormDatepicker,
  BFormTimepicker,
  BFormRadioGroup,
  BFormCheckbox,
  BOverlay,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import usePromoCodeForm from '../hooks/usePromoCodeForm'
import TargetsChecks from './TargetsChecks.vue'
import PromoUsers from './PromoUsers.vue'
import PromoCodeGeofence from './PromoCodeGeofence.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import PromoCodeServices from './PromoCodeServices.vue'
import PromoCodeGroups from './PromoCodeGroups.vue'
import promoCodesStore from '../store'
import PromoCodeSlices from './PromoCodeSlices.vue'
import zonesStore from '@/views/zones/zoneStoreModule'
import PromoCodePaymentMethods from './PromoCodePaymentMethods.vue'

export default {
  components: {
    BOverlay,
    BButton,
    BCard,
    PromoCodeSlices,
    BCardTitle,
    BForm,
    PromoCodePaymentMethods,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormRadioGroup,
    BRow,
    BCol,
    BFormDatepicker,
    BFormTimepicker,
    BFormCheckbox,
    TargetsChecks,
    PromoUsers,
    PromoCodeGeofence,
    PromoCodeServices,
    PromoCodeGroups,
    BFormCheckboxGroup,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('promoCodes', promoCodesStore)
    useRegisterStoreModule('zones', zonesStore)

    return {
      ...usePromoCodeForm(props, ctx),
    }
  },
}
</script>

<style scoped>
.promo-code__targets-card {
    border: 1px solid black;
    border-radius: 10px;
    padding: 10px;
}
</style>
